
(function(){
  "use strict";
  var state = {}, boxVisible = {}, activeP = null;
  var arts = Array.prototype.slice.call(document.querySelectorAll('article.product'));
  var bar  = document.getElementById('satc');
  var root = document.documentElement;

  /* ---- measured geometry, never an assumed breakpoint --------------------- */
  function measure(){
    var b = document.querySelector('.topbar') || document.querySelector(window.FENLO_HEADER_SEL || '#__fenlo_none__');
    root.style.setProperty('--fenlo-bannerH', (b ? b.offsetHeight : 0) + 'px');
    var n = document.querySelector('.anav');
    if (n) root.style.setProperty('--fenlo-navH', (n.offsetHeight || 62) + 'px');
  }

  /* ---- gallery ------------------------------------------------------------ */
  function galItems(pk){
    var ids = D[pk].media[state[pk]] || [], pool = D[pk]._m;
    if(!pool) return ids;                 /* un-deduped data still works */
    return ids.map(function(i){ return pool[i]; });
  }

  function showImage(pk, i){
    var g = document.getElementById(pk + '-gal'); if(!g) return;
    var items = galItems(pk); if(!items.length) return;
    if(i < 0) i = 0; if(i >= items.length) i = items.length - 1;
    var it = items[i], stage = g.querySelector('.stage');
    stage.classList.remove('zoom');
    if(it.schem){
      stage.innerHTML = '<div class="sch">' + (D[pk].schem || '') + '</div>';
      stage.setAttribute('aria-label', 'Dimension schematic');
      g.classList.add('is-schem');
    } else {
      /* same <figure>/<figcaption> shape the server renders — the caption is
         page content, not a decoration, so it must be the same element here */
      stage.innerHTML = '<figure><img src="' + it.src + '" alt="' + (it.alt || '') + '" width="' +
        (it.w || 1200) + '" height="' + (it.h || 1200) + '">' +
        (it.cap ? '<figcaption class="cap">' + it.cap + '</figcaption>' : '') + '</figure>';
      stage.setAttribute('aria-label', 'Product image, activate to zoom');
      g.classList.remove('is-schem');
    }
    Array.prototype.forEach.call(g.querySelectorAll('.thumb'), function(t, k){
      t.classList.toggle('sel', k === i); t.setAttribute('aria-selected', k === i ? 'true' : 'false');
    });
    Array.prototype.forEach.call(g.querySelectorAll('.dot'), function(t, k){
      t.classList.toggle('sel', k === i);
    });
    g.dataset.i = i;
  }

  /* THE GUARD: the server already rendered this variant's rail, dots and
     stage image, with the hero carrying fetchpriority="high". Re-rendering it
     on boot would throw that markup away, drop the priority hint and re-request
     the LCP image. data-built records WHICH variant is in the DOM; we only
     rebuild when the variant actually changed. Same identity-check discipline
     as setStickyCta() and the CTA block. */
  function buildGallery(pk){
    var g = document.getElementById(pk + '-gal'); if(!g) return;
    if(g.dataset.built === state[pk]) return;      /* server's markup stands */
    var items = galItems(pk), rail = g.querySelector('.rail'), dots = g.querySelector('.dots');
    if(!rail || !dots) return;
    g.classList.toggle('has-rail', items.length >= 4);
    g.classList.toggle('no-rail',  items.length <  4);
    var r = '', d = '';
    items.forEach(function(it, i){
      r += '<button class="thumb" type="button" role="tab" aria-selected="false" data-i="' + i +
           '" aria-label="Image ' + (i + 1) + '">' +
           (it.schem ? '<span class="thumb-dim">DIM</span>'
                     : '<img src="' + (it.thumb || it.src) + '" alt="" aria-hidden="true" loading="lazy" width="120" height="120">') +
           '</button>';
      d += '<button class="dot" type="button" data-i="' + i + '" aria-label="Image ' + (i + 1) + '"></button>';
    });
    rail.innerHTML = r; dots.innerHTML = d;
    g.dataset.built = state[pk];
    showImage(pk, 0);
  }

  document.addEventListener('click', function(e){
    var t = e.target.closest ? e.target.closest('.thumb,.dot') : null;
    if(!t) return;
    var g = t.closest('.gal'); if(!g) return;
    showImage(g.dataset.p, parseInt(t.dataset.i, 10) || 0);
  });

  /* zoom: origin from the click point, so it magnifies what was pointed at */
  document.addEventListener('click', function(e){
    var s = e.target.closest ? e.target.closest('.stage') : null;
    if(!s || s.parentNode.parentNode.classList.contains('is-schem')) return;
    if(s.classList.contains('zoom')){ s.classList.remove('zoom'); return; }
    var r = s.getBoundingClientRect();
    s.style.setProperty('--ox', ((e.clientX - r.left) / r.width * 100).toFixed(1) + '%');
    s.style.setProperty('--oy', ((e.clientY - r.top) / r.height * 100).toFixed(1) + '%');
    s.classList.add('zoom');
  });
  document.addEventListener('keydown', function(e){
    if((e.key === 'Enter' || e.key === ' ') && document.activeElement &&
       document.activeElement.classList.contains('stage')){
      e.preventDefault(); document.activeElement.click();
    }
  });

  /* ---- CTA state machine (R-081 + the 2026-07-29 stock rule) -------------- */
  /* Word-for-word twin of stock_state() / avail_line() / cta_markup() in the
     generator. Buyable on ANY channel is "In stock"; the channel is the second
     line, never the first, and 'none' is the only state allowed to say the
     product cannot be bought right now. */
  /* This colour's own attribution link, else the product's. Exact twin of
     amazon_url() in pdp_template.py — the two renderers must agree about
     where a swatch sends the shopper, or the server ships one href and the
     first swatch click silently replaces it with another. */
  function amazonHref(pk, v){ return (v && v.amz) || D[pk].amazon || null; }

  function stockState(pk, v){
    var amz = !!amazonHref(pk, v);
    if(v.onSite && v.onAmazon && amz) return 'both';
    if(v.onSite)                      return 'site';
    if(v.onAmazon && amz)             return 'amazon';
    return 'none';
  }

  /* Word-for-word twin of not_on_site_line(). Three Amazon states, three
     sentences; 'unknown' says nothing about Amazon because nobody checked. */
  function notOnSiteLine(pk){
    var store = D[pk].storeName, a = D[pk].amazonState;
    if(a === 'no')  return 'Not stocked at ' + store + ' or on Amazon today.';
    if(a === 'yes') return 'Not stocked at ' + store + ' today, and this ' +
                           D[pk].optionName.toLowerCase() + ' is not one of the ones on Amazon.';
    return 'Not stocked at ' + store + ' today.';
  }

  /* Mike, 2026-08-13: "dont need to show how many in stock, only show how
     many left when units is below 10 units". A running count on a shelf of
     257 is noise; a count on a shelf of 3 is the reason somebody buys today.
     LOW_STOCK is exclusive — 10 units says nothing, 9 says "Only 9 left".

     The number is Shopify's own inventory, injected per SKU by the section as
     FENLO_QTY. It is deliberately NOT applied to the 'amazon' state: that
     stock is FBA, Shopify cannot see it, and printing a number we cannot
     stand behind is worse than printing none. */
  var LOW_STOCK = 10;

  function lowStockNote(v){
    var q = window.FENLO_QTY && window.FENLO_QTY[
      String(v.sku || '').replace(/-FBA2?(?=(-|$))/g, '')];
    if (q == null || q <= 0 || q >= LOW_STOCK) return '';
    return q === 1 ? 'Only 1 left.' : 'Only ' + q + ' left.';
  }

  function availText(pk, v){
    var store = D[pk].storeName, st = stockState(pk, v);
    if(st === 'none')
      return ['Not in stock right now.', notOnSiteLine(pk), true];
    if(st === 'amazon')
      return ['In stock.', 'This ' + D[pk].optionName.toLowerCase() +
              ' ships from Amazon, not from ' + store + '.', false];
    var low = lowStockNote(v);
    return [low ? 'In stock at ' + store + '. ' + low
                : 'In stock at ' + store + '.', '', false];
  }

  /* ---- the restock module ------------------------------------------------
     Word-for-word twin of restock_markup(). It is built here and not merely
     revealed because the buy box arrives at 'none' by a swatch click, from a
     state whose CTA container held an Add to cart or an Amazon link. The SKU
     is NOT recomposed here — the server put this variant's finished key on
     v.restock.sku, so the fallback has exactly one implementation.

     v.restock is null on every variant somebody can buy, which is why this
     function reads through a `|| {}`: it is only ever called from the 'none'
     branch, and if that ever stops being true the node renders empty rather
     than inventing a request for a lamp that is in stock. */
  /* Same five substitutions, in the same order, as Python's
     html.escape(quote=True) — the two renderers must agree on the ampersand
     in "Shelves & Charging" as exactly as they agree on the words. */
  function esc(s){
    return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;')
                    .replace(/"/g,'&quot;').replace(/'/g,'&#x27;');
  }
  function restockMarkup(pk, v, name){
    var d = D[pk], r = v.restock || {};
    return '<details class="rs" id="' + pk + '-rs" data-restock ' +
           'data-rs-sku="' + esc(r.sku) + '">' +
           '<summary class="btn btn-primary rs-open">Notify me when it’s back</summary>' +
           '<div class="rs-panel">' +
           '<p class="rs-what">' + esc(d.title) + ' &mdash; ' +
           '<span class="rs-v">' + esc(name) + '</span></p>' +
           '<label class="rs-lab" for="' + pk + '-rs-email">Email address</label>' +
           '<input class="rs-in" id="' + pk + '-rs-email" type="email" name="contact[email]" ' +
           'autocomplete="email" spellcheck="false" placeholder="you@example.com">' +
           '<label class="rs-consent">' +
           '<input type="checkbox" class="rs-ck" name="contact[notify_consent]" value="yes">' +
           '<span>' + esc(d.restock.consent) + '</span></label>' +
           '<button type="button" class="btn btn-primary rs-send">Notify me</button>' +
           '<p class="rs-note" role="status">' + esc(d.restock.note) + '</p>' +
           '</div></details>';
  }

  /* Two out-of-stock variants share one ctaSig, so switching between them does
     NOT rebuild the container — which is the point (a half-typed address
     survives). This is what keeps the node truthful about which variant it is
     now asking about. */
  function syncRestock(pk, v, name){
    var rs = document.querySelector('#' + pk + '-ctas [data-restock]');
    if(!rs) return;
    setAttr(rs, 'data-rs-sku', (v.restock || {}).sku || '');
    setText(rs.querySelector('.rs-v'), name);
    var note = rs.querySelector('.rs-note');
    if(note && note.dataset.said){ delete note.dataset.said; setText(note, D[pk].restock.note); }
  }

  /* The amazon branch returns the Amazon CTA ALONE. "In stock" above and
     "Notify me when it's back" below was one screen telling the customer both
     things at once; notify-me is the 'none' state's control and nothing else. */
  function ctaMarkup(pk, v, name){
    var amz = amazonHref(pk, v), st = stockState(pk, v);
    var add = '<button class="btn btn-primary" type="button">Add to cart</button>';
    var notifyP = restockMarkup(pk, v, name);
    var rel = 'nofollow sponsored noopener';
    var amazonP = '<a class="btn btn-primary" href="' + amz + '" target="_blank" rel="' + rel + '">Buy on Amazon</a>';
    var amazonS = '<a class="btn btn-secondary" href="' + amz + '" target="_blank" rel="' + rel + '">Buy on Amazon</a>';
    if(st === 'both')   return add + amazonS;
    if(st === 'site')   return add;
    if(st === 'amazon') return amazonP;
    return (window.FENLO_LIQUID_RESTOCK ? '' : notifyP);
  }

  /* The server already rendered the default variant, so every write below is
     guarded: JS only touches a node whose content is actually changing. That
     is what makes boot a no-op rather than a second render of the same thing. */
  function setText(el, txt){ if(el && el.textContent !== txt) el.textContent = txt; }
  function setAttr(el, k, val){ if(el && el.getAttribute(k) !== val) el.setAttribute(k, val); }
  function ctaSig(pk, v){ return stockState(pk, v); }

  function selectVariant(pk, name, rebuild){
    var v = D[pk].variants[name]; if(!v) return;
    try{ setTimeout(function(){ window.dispatchEvent(new CustomEvent('fenlo:variant', {detail:{pk:pk, name:name, sku:v.sku}})); }, 0); }catch(e){}
    state[pk] = name;
    var set = function(id, txt){ setText(document.getElementById(pk + '-' + id), txt); };
    set('price', '$' + v.price);
    set('vname', name);
    set('sku', v.sku);
    var was = document.getElementById(pk + '-was');
    if(was){
      if(v.compareAt){
        var w = 'Regular price $' + v.compareAt;
        if(was.textContent !== w) was.innerHTML = '<span class="sr">Regular price </span>$' + v.compareAt;
        was.hidden = false;
      }
      else { setText(was, ''); was.hidden = true; }
    }
    var a = availText(pk, v), av = document.getElementById(pk + '-avail');
    if(av){ setText(av, a[0]); av.classList.toggle('off', a[2]); }
    var ch = document.getElementById(pk + '-availch');
    if(ch){ setText(ch, a[1]); ch.hidden = !a[1]; }
    var ctas = document.getElementById(pk + '-ctas');
    if(ctas && ctas.dataset.cta !== ctaSig(pk, v)){
      ctas.innerHTML = ctaMarkup(pk, v, name); ctas.dataset.cta = ctaSig(pk, v);
    }
    /* runs whether or not the container was rebuilt: 'none' -> 'none' is not a
       signature change, and the restock panel still has to change its mind
       about which variant it is capturing for */
    syncRestock(pk, v, name);
    /* a quantity stepper above a "Buy on Amazon" button is a lie */
    var q = document.getElementById(pk + '-qty'), disp = v.onSite ? '' : 'none';
    if(q && q.style.display !== disp) q.style.display = disp;
    /* EVERY row for this product, not just the buy box's. The sticky bar
       carries a second row of the same swatches (Mike, 2026-08-13) and a
       selection that moved in one place but not the other is worse than no
       second row at all — the shopper would see two different answers to
       "which colour am I buying". Selecting by [data-p] is what makes the
       two rows peers rather than a primary and a copy. */
    Array.prototype.forEach.call(
      document.querySelectorAll('.swrow[data-p="' + pk + '"] .sw'), function(s){
        var on = s.dataset.v === name;
        s.classList.toggle('sel', on); setAttr(s, 'aria-pressed', on ? 'true' : 'false');
      });
    if(rebuild !== false) buildGallery(pk);
    updateSticky();
  }

  document.addEventListener('click', function(e){
    var s = e.target.closest ? e.target.closest('.sw') : null; if(!s) return;
    var row = s.closest('.swrow'); if(!row) return;
    /* data-p first: the sticky row has no id to parse, and giving it one
       would duplicate the buy box's. */
    selectVariant(row.dataset.p || row.id.replace(/-swrow$/, ''), s.dataset.v, true);
  });

  /* quantity stepper */
  document.addEventListener('click', function(e){
    var b = e.target.closest ? e.target.closest('.qty button') : null; if(!b) return;
    var inp = b.parentNode.querySelector('input');
    var n = parseInt(inp.value, 10) || 1;
    n += (b.textContent.trim() === '+' ? 1 : -1);
    inp.value = Math.max(1, Math.min(99, n));
  });

  /* ---- restock: THE PREVIEW BUILD SENDS NOTHING ---------------------------
     out/*.html has no Shopify behind it, so this control does what the "Add to
     cart" button beside it does — it says so, and stops. The sending version
     is the {% form 'contact' %} in snippets/form__restock.liquid, which mails
     the shop's own contact address. There is no fetch here and there must not
     be one, on either build: Shopify's own 2024-07 change rejects a
     hand-rolled POST that carries no CAPTCHA token with a 400, and the CAPTCHA
     token is injected into a real {% form %} and nowhere else. */
  document.addEventListener('click', function(e){
    var b = e.target.closest ? e.target.closest('.rs-send') : null; if(!b) return;
    var rs = b.closest('[data-restock]'); if(!rs) return;
    var mail = rs.querySelector('.rs-in'), ok = rs.querySelector('.rs-ck');
    var note = rs.querySelector('.rs-note'), msg;
    if(!mail || !mail.value || mail.value.indexOf('@') < 0)
      msg = 'Enter an email address first.';
    else if(ok && !ok.checked)
      msg = 'Tick the box above so we know to email you.';
    else
      msg = 'Preview build — nothing was sent. On the live store this would email the ' +
            'shop: request_type=back_in_stock, email=' + mail.value + ', sku=' +
            (rs.getAttribute('data-rs-sku') || '') + '. No customer record is created.';
    if(note){ note.dataset.said = '1'; note.textContent = msg; }
  });

  /* The sticky bar's "Notify me" is the same offer as the buy box's, so it
     goes to it rather than being a second, differently-wired control.

     DEFECT (d), 2026-08-05. This used to identify the bar's button by
     comparing its textContent to the string 'Notify me'. That made a WORDING
     change — the most ordinary edit anyone could make to this file — silently
     disable the button instead of failing anything: it would still be there,
     still look like a button, and do nothing at all. The state is now carried
     as state, on data-satc-role, which no copy edit can touch. */
  document.addEventListener('click', function(e){
    var b = e.target.closest ? e.target.closest('.satc-cta') : null;
    if(!b || b.dataset.satcRole !== 'restock' || !activeP) return;
    var rs = document.querySelector('#' + activeP + '-ctas [data-restock]');
    if(!rs) return;
    rs.open = true;
    rs.scrollIntoView({block: 'center'});
    var mail = rs.querySelector('.rs-in'); if(mail) mail.focus();
  });

  /* ---- anchor nav: reveal off measured geometry, active by observer ------- */
  arts.forEach(function(art){
    var nav = art.querySelector('.anav'), hero = art.querySelector('.hero');
    if(!nav || !hero) return;
    function syncNav(){
      var off = parseFloat(getComputedStyle(root).getPropertyValue('--fenlo-bannerH')) || 0;
      nav.classList.toggle('on', hero.getBoundingClientRect().bottom < off + 8);
    }
    window.addEventListener('scroll', syncNav, {passive:true});
    window.addEventListener('resize', syncNav);
    window.addEventListener('load', syncNav);
    syncNav();

    if('IntersectionObserver' in window){
      var links = Array.prototype.slice.call(nav.querySelectorAll('a'));
      var targets = links.map(function(a){ return document.querySelector(a.getAttribute('href')); })
                         .filter(Boolean);
      /* a 10%-tall reading line in the upper-middle of the viewport; the
         section crossing it owns the highlight. Targets resolve from the
         hrefs themselves and are filtered, so a nav entry pointing at a
         suppressed section cannot throw. */
      var io = new IntersectionObserver(function(entries){
        entries.forEach(function(en){
          if(!en.isIntersecting) return;
          links.forEach(function(a){
            a.classList.toggle('act', a.getAttribute('href') === '#' + en.target.id);
          });
        });
      }, {rootMargin:'-25% 0px -65% 0px', threshold:0});
      targets.forEach(function(t){ io.observe(t); });
    }
  });

  /* ---- compare: differences-only toggle ---------------------------------- */
  document.addEventListener('change', function(e){
    if(!e.target.classList.contains('diffonly')) return;
    var tbl = e.target.closest('.sec').querySelector('.cmp'); if(!tbl) return;
    var on = e.target.checked;
    Array.prototype.forEach.call(tbl.querySelectorAll('tbody tr'), function(tr){
      if(tr.dataset.diff === '0') tr.style.display = on ? 'none' : '';
    });
  });

  /* ---- sticky add-to-cart bar -------------------------------------------- */
  /* THE TRAP: the Amazon branch must SWAP the element, not relabel it. A
     relabelled <button> has no href, cannot be middle-clicked, and silently
     carries no Amazon attribution. The identity check below compares tag AND
     label AND href — dropping href leaves a stale link across products.      */
  /* `role` is the stock state this button IS, carried as data rather than
     inferred from its words. Everything downstream that needs to know which
     of the three buttons this is asks for the role — see the restock handler
     above and DEFECT (d). It is part of the identity check too, so a stale
     role cannot survive a state change that happens to keep the same label. */
  function setStickyCta(tag, label, href, role){
    var cur = bar.querySelector('.satc-cta');
    var curHref = cur.tagName.toLowerCase() === 'a' ? (cur.getAttribute('href') || '') : '';
    if(cur.tagName.toLowerCase() === tag && cur.textContent === label &&
       curHref === (href || '') && (cur.dataset.satcRole || '') === (role || '')) return cur;
    var el = document.createElement(tag);
    el.className = 'btn btn-primary satc-cta';
    el.textContent = label;
    if(role) el.dataset.satcRole = role;
    if(tag === 'a'){ el.setAttribute('href', href); el.setAttribute('target', '_blank'); el.setAttribute('rel', 'nofollow sponsored noopener'); }
    else { el.type = 'button'; }
    cur.parentNode.replaceChild(el, cur);
    return el;
  }

  /* The bar's swatch row belongs to whichever product the bar is currently
     speaking for. It is CLONED from that product's buy box rather than built
     here: a JS swatch builder would be a second implementation of
     render_swatches(), and the two would drift the first time a swatch gained
     a state. Cloning also carries the out-of-stock slashes and the aria
     labels for free. */
  function stickySwatches(pk){
    var wrap = bar.querySelector('.satc-swrap'); if(!wrap) return;
    var row = wrap.querySelector('.swrow');
    if(row && row.dataset.p === pk) return;
    var src = document.getElementById(pk + '-swrow');
    if(!src || src.classList.contains('rows') || src.querySelectorAll('.sw').length < 2){
      wrap.hidden = true; if(row) wrap.removeChild(row); return;
    }
    var copy = src.cloneNode(true);
    copy.removeAttribute('id');
    copy.className = 'swrow satc-swrow';
    copy.setAttribute('role', 'group');
    copy.dataset.p = pk;
    if(row) wrap.replaceChild(copy, row); else wrap.appendChild(copy);
    wrap.hidden = false;
  }

  /* Buy now lives beside Add to cart and only exists in the states where it
     can mean anything. It is added and removed rather than hidden, so the
     grid/flex row never reserves space for a control that is not offered. */
  function setStickyBuyNow(on){
    var acts = bar.querySelector('.satc-acts'); if(!acts) return;
    var cur = acts.querySelector('.satc-buy');
    if(on && !cur){
      var el = document.createElement('button');
      el.type = 'button'; el.className = 'btn btn-secondary satc-buy';
      el.textContent = 'Buy now';
      acts.insertBefore(el, acts.firstChild);
    } else if(!on && cur){ acts.removeChild(cur); }
  }

  function updateSticky(){
    if(!bar) return;
    var pk = activeP;
    /* NO `dismissed` TEST, AND NO DISMISS BUTTON. Mike, 2026-08-13: the bar has
       to be there "scroll 到哪裡" — wherever you scroll. It used to carry an ×,
       and worse, ANY click on an Add to cart set dismissed[pk], so the floating
       control disappeared for the rest of the visit the first time somebody
       used it. The only reason to hide it is that the real buy box is on
       screen, which is not hiding — it is not duplicating. */
    if(!pk || boxVisible[pk]){ bar.classList.remove('on'); return; }
    var v = D[pk].variants[state[pk]]; if(!v) return;
    setText(bar.querySelector('.satc-t'), D[pk].shortTitle);
    stickySwatches(pk);
    var st = stockState(pk, v);
    /* Same low-stock rule as the buy box, and for the same reason: it is the
       line that makes somebody buy today. Not applied to the Amazon state —
       that stock is FBA and Shopify cannot see it. */
    var low = st === 'site' || st === 'both' ? lowStockNote(v) : '';
    setText(bar.querySelector('.satc-v'),
      state[pk] + ' · ' + (st === 'none' ? 'Not in stock' : 'In stock') +
      (low ? ' · ' + low.replace(/\.$/, '') : ''));
    setText(bar.querySelector('.satc-p'), '$' + v.price);
    if(st === 'site' || st === 'both') setStickyCta('button', 'Add to cart',   null,          'cart');
    else if(st === 'amazon')           setStickyCta('a',      'Buy on Amazon', amazonHref(pk, v),  'amazon');
    else                               setStickyCta('button', 'Notify me',     null,          'restock');
    setStickyBuyNow(st === 'site' || st === 'both');
    bar.classList.add('on');
  }

  function syncSticky(){
    var mid = window.innerHeight / 2;
    arts.forEach(function(art){
      var pk = art.dataset.p, ar = art.getBoundingClientRect();
      if(ar.top <= mid && ar.bottom >= mid) activeP = pk;
      var box = art.querySelector('.buybox');
      if(box){ var br = box.getBoundingClientRect(); boxVisible[pk] = br.bottom > 0 && br.top < window.innerHeight; }
    });
    if(!activeP && arts.length) activeP = arts[0].dataset.p;
    /* The cart bridge is a separate file and cannot see this closure, so the
       active product is published. Its sticky-bar branch used to read
       window.__fenloActive, which nothing ever set — it only worked because
       every ported page has exactly one <article.product> to fall back to. */
    window.__fenloActive = activeP;
    updateSticky();
  }

  /* ---- video facade -------------------------------------------------------
     One click, one iframe, and only then. Before the click the module has made
     zero requests off cdn.shopify.com, which is why a YouTube clip does not
     cost this page a third-party connection on load. A page with no video, or
     with a self-hosted one, has no D[pk].video and this loop does nothing. */
  document.addEventListener('click', function(e){
    var btn = e.target.closest ? e.target.closest('.vid-play') : null;
    if(!btn) return;
    var fac = btn.parentNode, pk = fac.dataset.p, v = D[pk] && D[pk].video;
    if(!v || !v.embed) return;
    var f = document.createElement('iframe');
    f.src = v.embed + '&autoplay=1';
    f.title = v.label || 'Video';
    f.allow = 'accelerometer; encrypted-media; gyroscope; picture-in-picture; fullscreen';
    f.setAttribute('allowfullscreen', '');
    f.setAttribute('loading', 'lazy');
    f.className = 'vid-if';
    fac.replaceChild(f, btn);
    f.focus();
  });

  /* ---- boot -------------------------------------------------------------- */
  arts.forEach(function(art){
    var pk = art.dataset.p;
    var order = D[pk].order;
    /* the server already rendered this variant's swatch, price, availability
       line and CTA; booting on any other one would be a visible re-render */
    state[pk] = D[pk].variants[D[pk].defaultV] ? D[pk].defaultV : order[0];
    buildGallery(pk);
    selectVariant(pk, state[pk], false);
  });

  window.addEventListener('scroll', syncSticky, {passive:true});
  window.addEventListener('resize', function(){ measure(); syncSticky(); });
  window.addEventListener('load',   function(){ measure(); syncSticky(); });
  measure(); syncSticky();

  /* A #hash landing is applied AFTER first paint and sometimes after load, so
     every scroll-derived state is re-derived at 0 / 80 / 350ms and on hashchange. */
  function resync(){ window.dispatchEvent(new Event('scroll')); }
  window.addEventListener('hashchange', resync);
  window.addEventListener('load', function(){ resync(); setTimeout(resync, 80); setTimeout(resync, 350); });
  setTimeout(resync, 0);
})();
